// extracted by mini-css-extract-plugin
export var container = "_53-0";
export var fallback = "_53-5";
export var fallbackIcon = "_53-6";
export var hidden = "_53-2";
export var image = "_53-3";
export var loaded = "_53-4";
export var placeholder = "_53-1";